import { useState, useEffect, useRef } from 'react';

/**
 * keeps track of piece of state and returns whether that value has been updated
 * igno
 * @param dependency
 * @param isUpdate
 * @returns [isUpdate, reset()]
 */
export const useIsStateUpdate = <T extends unknown>(
  dependency: T,
  isUpdate: (prev: T, current: T) => boolean
): [boolean, () => void] => {
  const [state, setState] = useState(dependency);
  const [isUpdated, setIsUpdated] = useState(false);
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      if (isUpdate(state, dependency)) {
        setIsUpdated(true);
      }
      setState(dependency);
    }
  }, [dependency]);
  return [isUpdated, () => setIsUpdated(false)];
};
